import { html, css, nothing, type TemplateResult } from "lit";
import { customElement, state } from "lit/decorators.js";
import { localized } from "@lit/localize";

import type { VideoContent } from "../../types/content";
import { WebKioskPageElement } from "../web-kiosk-page";

declare global {
  interface HTMLElementTagNameMap {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    "web-kiosk-video": WebKioskVideoElement;
  }
}
@localized()
@customElement("web-kiosk-video")
export class WebKioskVideoElement extends WebKioskPageElement {
  @state() content: VideoContent | undefined = undefined;

  connectedCallback(): void {
    super.connectedCallback();

    this.dispatchEvent(
      new CustomEvent("web-kiosk-video-open", {
        bubbles: true,
      })
    );
  }

  fireCloseEvent(): void {
    this.dispatchEvent(
      new CustomEvent("web-kiosk-video-close", {
        bubbles: true,
      })
    );
  }

  render(): TemplateResult | typeof nothing {
    if (!this.content) {
      return nothing;
    }

    return html`<video
        loop
        muted
        autoplay
        preload="auto"
        src=${this.content.mediaUrl}
        poster=${this.content.mediaPosterImg}
        @click=${this.fireCloseEvent}
      ></video>
      <div id="learn-more">
        <span id="pointer">
          <img src=${this.content.pointerImg} alt=${this.content.pointerAlt} />
        </span>
        <span id="message"> ${this.content.learnMore} </span>
      </div>`;
  }

  static styles = css`
    #learn-more {
      display: flex;
      position: absolute;
      align-items: center;
      right: 0;
      top: 66px;
      padding: 20px 73px 20px 24px;
      background: #fff;
      border: 4px solid #e52600;
      border-right: none;
      border-radius: 88px 0 0 88px;
      box-shadow: 0 8px 30px #0a14142b;
      animation: shake 1.2s infinite;
      -webkit-animation: shake 1.2s infinite;
    }

    #pointer {
      animation: pulse 1.2s infinite;
      -webkit-animation: pulse 1.2s infinite;
    }

    #message {
      width: 352px;
      margin-left: 8px;
      color: #264385;
      font-size: 32px;
      font-weight: 700;
      line-height: 38px;
      animation: shake 1.2s infinite;
      -webkit-animation: shake 1.2s infinite;
    }

    @keyframes pulse {
      0% {
        transform: scale(0.7);
      }

      50% {
        transform: scale(1);
      }

      100% {
        transform: scale(0.7);
      }
    }

    @-webkit-keyframes pulse {
      0% {
        transform: scale(0.7);
      }

      50% {
        transform: scale(1);
      }

      100% {
        transform: scale(0.7);
      }
    }

    @keyframes shake {
      0% {
        transform: translateX(0);
      }

      50% {
        transform: translateX(0.3px);
      }

      100% {
        transform: translateX(0);
      }
    }

    @-webkit-keyframes shake {
      0% {
        transform: translateX(0);
      }

      50% {
        transform: translateX(0.3px);
      }

      100% {
        transform: translateX(0);
      }
    }
  `;
}
